import { types } from 'mobx-state-tree';

import { LicenceTypeValuesQuebec } from '../definitions/LicenseTypeValues';
import LicenceBase from './LicenceBase';


const LicenceQC = LicenceBase
    .named('LicenceQC')
    .props({
        // Note: firstLicenceType is also declared on LicenceON with
        // the same key, but different emum values.  Mobx will accept 
        // both LicenseTypeValuesOntario or LicenseTypeValuesAlberta
        // as valid values to resolve the union on ./Drivers.licencing
        firstLicenceType: types.enumeration(
            Object.values(LicenceTypeValuesQuebec),
        ),

        hasClass5PLicence: types.maybeNull(types.boolean),
        class5PLicenceAge: types.maybeNull(types.number),

        hasClass5Licence: types.maybeNull(types.boolean),
        class5LicenceAge: types.maybeNull(types.number),
    });

export default LicenceQC;
